import { getTenantApiToken } from './getTenantApiToken';
import type { GetTenantApiTokenOptions } from './getTenantApiToken';

/**
 * Hotel API token boundary.
 *
 * Thin alias over the shared tenant token resolver (`getTenantApiToken`),
 * kept so hotel call sites keep reading in their own domain language.
 */
export async function getHotelApiToken(options?: GetTenantApiTokenOptions): Promise<string | null> {
  return getTenantApiToken(options);
}
